import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { DropdownBaseQueryInterface } from '@zaoblako/shared/common/dtos/dropdown-base-query.dto';
import { PaginationFindInterface } from '@zaoblako/shared/common/dtos/pagination-find.dto';
import type { ContragentFindInterface } from '@zaoblako/shared/modules/client/dtos/contragent/contragent-find.dto';
import { ContragentService } from '@zaoblako/web/core/services/client/contragent.service';
import { BaseMultiSelectComponent } from '@zaoblako/web/shared/components/base-multi-select/base-multi-select.component';
import { MultiSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/multi-select/multi-select.component';
import { SpinnerComponent } from '@zaoblako/web/shared/dumbs/spinner/spinner.component';
import { SafeHtmlPipe } from '@zaoblako/web/shared/pipes/safe-html.pipe';
import { Observable } from 'rxjs';

@Component({
  selector: 'crm-contragent-multi-select',
  standalone: true,
  imports: [CommonModule, MultiSelectComponent, SpinnerComponent, SafeHtmlPipe],
  templateUrl: './contragent-multi-select.component.html',
  styleUrls: ['./contragent-multi-select.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContragentMultiSelectComponent
  extends BaseMultiSelectComponent<ContragentFindInterface>
  implements OnInit, OnChanges {
  public availableModule = 'BASIS';
  protected readonly entityCacheKind = 'contragent';

  @Input() public clientIds: number[] = [];
  @Input() public onlyWithSalaryControl = false;

  public constructor(private readonly contragentService: ContragentService) {
    super();
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (
      (changes.clientIds && !changes.clientIds.firstChange) ||
      (changes.onlyWithSalaryControl && !changes.onlyWithSalaryControl.firstChange)
    ) {
      this.firstLoad();
    }
  }

  protected override getRegistryCacheContext(): Record<string, unknown> {
    return { clientIds: this.clientIds, onlyWithSalaryControl: this.onlyWithSalaryControl };
  }

  public findWithPagination(
    queryParams: Partial<DropdownBaseQueryInterface>
  ): Observable<PaginationFindInterface<ContragentFindInterface>> {
    return this.contragentService.getAll({
      ...queryParams,
      clientIds: this.clientIds,
      onlyWithSalaryControl: this.onlyWithSalaryControl || undefined
    });
  }

  public toContragent(contragent: any): ContragentFindInterface {
    return contragent as ContragentFindInterface;
  }
}
